<template>
	<ViewFeedItem class="view-feed-venuenearby">
		<template v-slot:header>
			<ViewLayoutModuleHeader title="Places to play near you">
				<RouterLink v-bind:to="{ name: 'PagePlaces' }">
					<strong>View All</strong>
				</RouterLink>
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyVenueList
				v-bind:useLocation="true"
				v-bind:venueCollection="venueCollection"
				v-on:venue:select="Handle_OnSelectVenue"
				view="horizontal"
			/>

			<!-- <div v-if="$store.getters['authentication/isSuperAdmin']">
				<small>
					{{ $store.getters['location/latitude'] }}
					&ndash;
					{{ $store.getters['location/longitude'] }}
					&ndash;
					{{ $store.getters['location/timestamp'] }}
					&ndash;
					{{ debugRenders }}
				</small>
			</div> -->
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import * as Config from '@/Config';
	import * as Factory from '@/App/Factory';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, event, mounted } from '@/Utility/Decorators';

	/**
	 * Location change + fetch is handled by the List component.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedVenueNearby extends ViewBase {
		/**
		 * @type ChalkySticks/Collection/Venue
		 */
		@Prop({
			default: () => {
				// return Factory.Venue.collection({ limit: 8 }).cache(Config.App.CACHE_GENERAL_TTL);
				// return ChalkySticks.Core.ChalkySticks.make<ChalkySticks.Collection.Venue>('nearbyVenueCollection');
				// return ChalkySticks.Core.app('nearbyVenueCollection');
				return ChalkySticks.Core.app('nearbyVenueCollection');
			},
		})
		public venueCollection!: ChalkySticks.Collection.Venue;

		/**
		 * @type number
		 */
		private debugRenders: number = 0;

		/**
		 * @return void
		 */
		@mounted
		public attachEvents(): void {
			this.venueCollection.on('complete', this.Handle_OnVenueCollectionComplete);
		}

		/**
		 * @return void
		 */
		@beforeDestroy
		public detachEvents(): void {
			this.venueCollection.off('complete', this.Handle_OnVenueCollectionComplete);
		}

		/**
		 * @return void
		 */
		protected sortModelsByDistance(): void {
			this.venueCollection.models = this.venueCollection.models.sort((venueA, venueB): number => {
				const { latitude, longitude } = this.$store.getters['location/coordinates'];
				const distanceToA = venueA.getDistance(latitude, longitude);
				const distanceToB = venueB.getDistance(latitude, longitude);

				return distanceToA - distanceToB;
			});
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnVenueCollectionComplete(): Promise<void> {
			this.sortModelsByDistance();

			this.debugRenders++;
		}

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.$store.dispatch('gotoVenue', venueModel);
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-venuenearby {
		--chalky-utility-gallery-aspect-ratio: 4 / 3;

		.chalky.venue-list.view-horizontal .list {
			padding-bottom: 1rem;
		}
	}
</style>
